<template>
  <v-row>
    <v-col cols="12">
      <v-text-field v-model="data.name" label="name"></v-text-field>
    </v-col>
    <v-col cols="12">
      <v-textarea
        rows="2"
        v-model="data.description"
        label="Description"
      ></v-textarea>
    </v-col>

    <v-col cols="12">
      <select-multi-groups v-model="data.groups"> </select-multi-groups>
    </v-col>
    <v-col cols="12"
      ><select-multi-categories v-model="data.similarCategories">
      </select-multi-categories
    ></v-col>

    <v-col cols="12"
      ><select-multi-keywords v-model="data.keywords"> </select-multi-keywords
    ></v-col>

    <v-col cols="12">
      <v-switch v-model="data.featured" label="Featured"></v-switch>
    </v-col>
  </v-row>
</template>

<script>
import { Strings, axios } from '../../../utils'
import SelectMultiGroups from '../../../components/SelectMultiGroups'
import SelectMultiCategories from '../../../components/SelectMultiCategories'
import SelectMultiKeywords from '../../../components/SelectMultiKeywords.vue'
export default {
  name: 'CategoryForm',
  props: ['data'],
  components: {
    SelectMultiGroups,
    SelectMultiCategories,
    SelectMultiKeywords
  },

  data() {
    return {
      icons: ['mdi-rewind', '', 'mdi-fast-forward'],
      baseUrl: Strings.baseUrl,
      deleteFileLoading: false
    }
  },
  methods: {
    deleteFile() {
      this.deleteFileLoading = true

      if (this.data.id) {
        console.log('deleting blog media for id ', this.data.id)
        axios
          .delete(`api/admin/blogs/${this.data.id}/delete-media`)
          .then(res => {
            if (res.data === 1) {
              console.log('done')
              this.data.image = null
              this.deleteFileLoading = false
            }
          })
          .catch(err => console.log(err))
      } else {
        console.log('deleting media for path ', this.data.image)
        axios
          .get(`api/admin/file-delete?path=${this.data.image}`)
          .then(res => {
            if (res.data === 1) {
              console.log('done')
              this.data.image = null
              this.deleteFileLoading = false
            }
          })
          .catch(err => console.log(err))
      }
    }
  }
}
</script>

<style scoped></style>
